import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHowToReg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#how-to-reg_svg__a)">
      <path
        fill="#263E6A"
        d="M2.942 18.615V16.97q0-.767.377-1.233.378-.465.954-.763 1.275-.65 2.51-1.004t3.16-.354q.75 0 1.327.046.578.046 1.022.139l-.904.904a5 5 0 0 0-.652-.07q-.378-.018-.794-.019-1.774 0-3.033.368-1.26.367-2.159.867-.456.24-.632.504-.176.262-.176.615v.646h5.866l1 1zM15.3 19.708l-2.758-2.758.708-.708 2.05 2.05 5.05-5.05.708.708zm-5.358-8.323a2.9 2.9 0 0 1-2.118-.882 2.9 2.9 0 0 1-.882-2.118q0-1.238.882-2.12a2.9 2.9 0 0 1 2.118-.88 2.9 2.9 0 0 1 2.12.88q.88.882.88 2.12t-.88 2.118a2.9 2.9 0 0 1-2.12.882m0-1q.825 0 1.413-.588.587-.588.587-1.412 0-.825-.587-1.413a1.93 1.93 0 0 0-1.413-.587q-.825 0-1.412.587a1.93 1.93 0 0 0-.588 1.413q0 .825.588 1.412.587.588 1.412.588"
      />
    </g>
    <defs>
      <clipPath id="how-to-reg_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHowToReg;
